<template>
  <div
    class="text-gray-400 hover:text-bc-blue flex-grow text-center cursor-pointer"
    @click.stop.prevent="click()"
  >
    <aw-icon
      icon="heading-second-second"
      class="cursor-pointer w-6 h-6 "
    ></aw-icon>
    <div class="pt-2 leading-none">{{ $t('Heading') }}</div>
  </div>
</template>

<script>
import BaseAddElement from '../../../mixins/BaseAddElement'
export default {
  mixins: [BaseAddElement],
  emits: ['update:modelTakeChildren'],
  props: {
    takeChildrenIndex: Number,
    modelTakeChildren: Object
  },
  computed: {
    takeChildrenParent: {
      get() {
        return this.modelTakeChildren
      },
      set(val) {
        this.$emit('update:modelTakeChildren', val)
      }
    }
  },
  methods: {
    takeChildren(parent, fromIndex) {
      let nextHeaderIndex = parent.children.length
      for (let index = fromIndex; index < parent.children.length; index++) {
        if (parent.children[index].type === 'header') {
          nextHeaderIndex = index
          break
        }
      }

      return parent.children.splice(fromIndex, nextHeaderIndex - fromIndex)
    },
    click() {
      const children = this.takeChildren(
        this.takeChildrenParent,
        this.takeChildrenIndex
      )

      this.addChild('header', { header: this.$t('Header') }, children, {
        take_children_parent__bc_document_data_rev_id:
          this.takeChildrenParent.id,
        take_children_index: this.takeChildrenIndex
      })

      this.$emit('onselect')
    }
  }
}
</script>
